import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "js-step-3" }
const _hoisted_2 = {
  key: 0,
  class: "o-grid"
}
const _hoisted_3 = {
  key: 1,
  class: "o-grid"
}
const _hoisted_4 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 o-grid__cell--offset-3-480" }
const _hoisted_5 = { class: "o-grid o-grid--no-y-gutter o-grid--align-flex-end" }
const _hoisted_6 = { class: "o-grid__cell o-grid__cell--12" }
const _hoisted_7 = { class: "o-grid__cell o-grid__cell--9" }
const _hoisted_8 = { class: "c-list" }
const _hoisted_9 = { class: "o-grid o-grid--align-middle u-mar-t-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Steps = _resolveComponent("Steps")!
  const _component_tarifauswahl = _resolveComponent("tarifauswahl")!
  const _component_leistungstabelle = _resolveComponent("leistungstabelle")!
  const _component_tarifoptionen = _resolveComponent("tarifoptionen")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_produktmodul_ausschluss = _resolveComponent("produktmodul-ausschluss")!
  const _component_produktmodul = _resolveComponent("produktmodul")!
  const _component_hug_rabatt = _resolveComponent("hug-rabatt")!
  const _component_maklerrabatt = _resolveComponent("maklerrabatt")!
  const _component_beitrag = _resolveComponent("beitrag")!
  const _component_email_oder_herunterladen = _resolveComponent("email-oder-herunterladen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Steps, {
      active: 2,
      items: _ctx.navItems,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_tarifauswahl, { tarifauswahlInformationen: _ctx.tarifauswahlInformationen }, null, 8, ["tarifauswahlInformationen"]),
      _createVNode(_component_leistungstabelle, {
        aktiveLinie: _ctx.aktiveLinie,
        inhalt: _ctx.leistungen,
        link: _ctx.getTIB()
      }, null, 8, ["aktiveLinie", "inhalt", "link"]),
      _createVNode(_component_tarifoptionen, { tarifoptionInformationen: _ctx.tarifoptionInformationen }, null, 8, ["tarifoptionInformationen"]),
      (_ctx.piniaStore.state.isMakler && _ctx.piniaStore.state.tarifinformationen.sfr === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 o-grid__cell--offset-3 notice-box" }, [
              _createElementVNode("strong", null, "Hinweis:"),
              _createTextVNode(" Das SFR-Modell ist obligatorisch, wenn mehr als 1 Vorschaden und eine Schadenquote >60 % dem Antrag zu Grunde liegen ")
            ], -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.fehler.vorschaedenAnzahl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.vorschaedenAnzahl
                  }, null, 8, ["fehler-text"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.sollAusschlussZeigen())
        ? (_openBlock(), _createBlock(_component_produktmodul_ausschluss, {
            key: 2,
            "produktmodul-auschluss": _ctx.ausschlussModul
          }, null, 8, ["produktmodul-auschluss"]))
        : _createCommentVNode("", true),
      _createVNode(_component_produktmodul, {
        produktmodule: _ctx.produktmodule,
        "zeige-icons": true
      }, {
        unbekannteZuersZoneHinweis: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "o-grid__cell o-grid__cell--9" }, [
            _createElementVNode("ul", { class: "c-list" }, [
              _createElementVNode("li", { class: "c-list__item c-list__item_warning" }, " Der Beitrag kann ggf. steigen, da keine ZÜRS-Zone ermittelt werden konnte. ")
            ])
          ], -1)
        ])),
        vhvElementarHinweis: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", {
                class: _normalizeClass([{ 'c-list--inactive': _ctx.piniaStore.state.zuersZone.zone === '4' }, "c-list__item"])
              }, _toDisplayString(_ctx.ueberschwemmungText), 3),
              _cache[3] || (_cache[3] = _createElementVNode("li", { class: "c-list__item" }, "Erdsenkung, Erdrutsch", -1))
            ])
          ])
        ]),
        _: 1
      }, 8, ["produktmodule"]),
      _createElementVNode("div", _hoisted_9, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }, [
          _createElementVNode("h2", { class: "u-form-heading unset-text-align" }, "Rabatt")
        ], -1)),
        _createVNode(_component_hug_rabatt)
      ]),
      _createVNode(_component_maklerrabatt, { fehler: _ctx.fehler }, null, 8, ["fehler"]),
      _createVNode(_component_beitrag, { onNextPage: _ctx.nextPage }, null, 8, ["onNextPage"]),
      _createVNode(_component_email_oder_herunterladen, {
        produkt: "vgv",
        "tracking-zusatz": "vergleich"
      })
    ])
  ], 64))
}